import { InjectionToken } from '@angular/core';

export interface KeycloakConfig {
  production: boolean;
  oauthServerHost: string;
  oauthRealm: string;
  oauthClientId: string;
  superAdminRole: string;
  responseType: string;
  scope: string;
}

export const KEYCLOAK_CONFIG = new InjectionToken<KeycloakConfig>(
  'KEYCLOAK_CONFIG',
);
